import { HomeCommand } from "slotworks/commands/betbar/home-command";
import Layers from "slotworks/graphics/layers/layers";
import { Control } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import AbstractButtonControl from "../abstract/abstract-button-control";

export default class HomeButtonControl extends AbstractButtonControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);
    }

    protected onClick() {
        if (this.options) {
            HomeCommand(this.options.homeURL, this.options.onSessionClose).execute();
        }
    }
}
